import { render, staticRenderFns } from "./Updateoffercategories.vue?vue&type=template&id=9bad55b0&scoped=true&"
import script from "./Updateoffercategories.vue?vue&type=script&lang=js&"
export * from "./Updateoffercategories.vue?vue&type=script&lang=js&"
import style0 from "./Updateoffercategories.vue?vue&type=style&index=0&id=9bad55b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bad55b0",
  null
  
)

export default component.exports